'use client';

import { UserCircle } from 'lucide-react';
import { useLanguage } from '@/contexts/language-context';

export default function PersonaSelector() {
  const { t } = useLanguage();

  const personas = [
    {
      id: 'default' as const,
      nameKey: 'persona.default',
      icon: UserCircle,
    },
    // {
    //   id: 'rap' as const,
    //   nameKey: 'persona.rap',
    //   icon: Mic,
    // },
    // {
    //   id: 'anime_girl' as const,
    //   nameKey: 'persona.cute',
    //   icon: Sparkles,
    // },
    // {
    //   id: 'wild' as const,
    //   nameKey: 'persona.wild',
    //   icon: Flame,
    // },
  ];

  return (
    <div className="relative group flex items-center">
      {personas.map((persona, index) => {
        const Icon = persona.icon;
        // const isSelected = selectedPersona === persona.id;

        return (
          <button
            key={persona.id}
            aria-label={t(persona.nameKey)}
            className={`flex h-8 w-8 items-center justify-center gap-0 overflow-hidden rounded-full p-0 text-xs font-medium transition-all duration-300 ease-out cursor-pointer sm:h-auto sm:w-auto sm:gap-1.5 sm:px-3 sm:py-1.5 sm:text-sm ${
              'bg-[#ffffff]/8 text-white border border-[#ffffff]/8 opacity-100'
              // : ' text-white border-[#ffffff]/8 hover:bg-[#ffffff]/8 border  opacity-0 w-0 px-0 py-1.5 group-hover:opacity-100 group-hover:w-auto group-hover:px-3'
            } ${index > 0 ? 'group-hover:ml-2' : ''}`}>
            <Icon className="h-3.5 w-3.5 shrink-0 sm:h-4 sm:w-4" />
            <span className="hidden whitespace-nowrap sm:inline">{t(persona.nameKey)}</span>
          </button>
        );
      })}
    </div>
  );
}
